import React, { useEffect } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import {usePage} from "../../Context/PageContext"
import { useQuery } from "react-query";
import { fetchFaq } from "../../Data/page_service";
import "./Faq.css";


export const Faq = () => {
  const {pages , setPages}=usePage()
  const { refetch } = useQuery('pageFaq', () => fetchFaq(setPages) , 
  {
     refetchOnWindowFocus: true,
    cacheTime: 1000,
    refetchInactive:true,});

let faqTab = [];
    if (pages) {

      var faqPages = Object.values(pages)
    
       faqTab = faqPages?.sort((a,b)=> a.id - b.id ? -1 : 1,);
   
     }


  return (
    <div className="accordion-demo">
      <div className="card">
        <img src="/paris.jpg" alt="" />
        <h5 className="Title-faq">Foire aux questions</h5>
            <Accordion>
            {pages.length >0  && 
              faqTab?.map((f) =>(
              <AccordionTab header={f.titre} key={f.titre}>
                <p dangerouslySetInnerHTML={{ __html: f.contenu }}></p>
              </AccordionTab>
              ))}
            </Accordion>
        
      </div>
    </div>
  );
};
